import React from "react";
import styled from "styled-components";
import { AddButton } from "./styles";
import Typography from "../../designComponents/Typography";

interface VatPercentageType {
  vatPercentage?: number;
}

const IconButton = styled.button<{ hoverColor: string }>`
  font-size: 0.875rem;
  padding: 6px 14px;
  border: 1px solid #4b5563;
  background-color: transparent;
  color: #4b5563;
  border-radius: 6px;
  cursor: pointer;
  transition:
    background-color 0.2s,
    color 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;

  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
    color: white;
  }
`;

interface ViewVatPercentageProps {
  data?: VatPercentageType; // make optional if it can be null/undefined
  onEditClick: (value: VatPercentageType) => void;
  onAddClick: VoidFunction;
}

const ViewVatPercentage: React.FC<ViewVatPercentageProps> = ({
  data,
  onEditClick,
  onAddClick,
}) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <p>Trade Vat Percentage</p>
      </div>

      {!data?.vatPercentage ? (
        <>
          <Typography style={{ color: "#f23f5e" }}>
            No Vat Percentage Found!
          </Typography>
          <AddButton onClick={onAddClick} style={{ alignSelf: "flex-start" }}>
            Add
          </AddButton>
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography>Vat Percentage: {data.vatPercentage}%</Typography>

          <div style={{ display: "flex", gap: 10 }}>
            <IconButton
              hoverColor="#0000FF"
              onClick={() => onEditClick(data)}
              title="Edit"
            >
              Edit
            </IconButton>
          </div>
        </div>
      )}
    </div>
  );
};

export default ViewVatPercentage;
